import React, { Component } from 'react'

import { TabsPanelWithLock } from '../../components/tab-panel-with-lock'
import { ContextToolbar } from '@guillotinaweb/react-gmi'
import { useTraversal, TraversalContext } from '@guillotinaweb/react-gmi'
import { PanelPermissions } from '@guillotinaweb/react-gmi'
import { PanelItems } from '@guillotinaweb/react-gmi'
import { Select } from '@guillotinaweb/react-gmi'
import { Loading } from '@guillotinaweb/react-gmi'
import { Input } from '@guillotinaweb/react-gmi'

import { RichTextEditor } from '../../components/RichTextEditor'

import { AuditLogTab } from '../../common/auditlog'
import { DnD } from '../../common/dnd'
import { Field, BaseField, ImageEditor } from '../../common/field'
import { I18NField } from '../../components/i18nfield'
import { SEOTab } from '../../components/seo-tab'
import { SubmenuTab } from '../../components/submenu-tab'
import { Suggester } from '../../common/text_suggester'
import { getOrSet } from '../../utils'

import './zonas_editor.css'

const Empty = () => null

const TIPO_ZONA = {
  pais: 'Pais',
  supraregion: 'Supraregion',
  subdivision: 'Subdivision',
  ao: "Appellation d'origine contrôlée",
  ce: 'Región para cervezas',
  cg: 'Denominazione di Origine Controllata e Garantita',
  de: 'Región para destilados',
  dc: 'Denominación de Origen Calificada',
  do: 'Denominación de Origen',
  it: 'Indicazione Geografica Tipica',
  oc: 'Denominazione di Origine Controllata',
  vp: 'Vino de Pago',
  vt: 'Vinos de la tierra',
  va: 'Vino da Tavola',
}

const CONSEJO_REGULADOR = [
  ['Dirección', 'direccion'],
  ['Código postal', 'codigo_postal'],
  ['Localidad', 'localidad'],
  ['Telefono', 'telefono'],
  ['Email', 'email'],
  ['Web', 'web'],
  ['Año de fundación', 'anyo_fundacion'],
  ['# Elaboradores', 'num_elaboradores'],
  ['Superfície', 'superficie'],
]

const CALIFICACIONES = {
  5: 'E-Excelente',
  4: 'MB-Muy Buena',
  3: 'B-Buena',
  2: 'N-Normal',
  1: 'M-Mediana',
}

const IMAGES_KEYS = [
  ['Background', 'img_bg', 600],
  ['Mapa país', 'img_pais', 600],
  ['Mapa región', 'img_region', 600],
  ['Logo DO', 'img_logo', 150],
]

const GUILLOTINA_KEYS = [
  '@id',
  '@name',
  '@static_behaviors',
  '@type',
  '@uid',
  'creation_date',
  'is_folderish',
  'items',
  'length',
  'modification_date',
  'parent',
  'title',
  'type_name',
  'uuid',
  '__behaviors__',
]

class ZonaEditor extends Component {
  constructor(props) {
    super(props)

    this.state = {
      zona: null,
      cachedBodegas: {},
      newClasificacionAnyadaPunt: Object.keys(CALIFICACIONES).sort()[0],
    }

    // ref
    this.newClasificacionAnyada = null

    this.save = this.save.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleEditorChange = this.handleEditorChange.bind(this)
  }

  render() {
    let zona = this.state.zona

    if (zona === null) return <Loading />

    const canModifyContent = this.context.hasPerm('guillotina.ModifyContent')

    return (
      <div className="columns">
        <div className="column">
          <Field label="Identificador" disabled="true" value={zona.old_id} />

          <BaseField label="Tipo">
            <Select
              value={zona.tipo}
              onChange={(e) => {
                this.setState({ zona: { ...zona, tipo: e.target.value } })
              }}
              options={Object.keys(TIPO_ZONA).map((id) => ({
                value: id,
                text: TIPO_ZONA[id],
              }))}
            />
          </BaseField>

          <BaseField label="Nombre">
            <I18NField Widget={Empty}>
              {(lang) => (
                <Input
                  value={zona.nombre[lang]}
                  onChange={(nombre) =>
                    this.setState({
                      zona: {
                        ...zona,
                        nombre: {
                          ...zona.nombre,
                          [lang]: nombre,
                        },
                      },
                    })
                  }
                />
              )}
            </I18NField>
          </BaseField>

          <BaseField label="Comentario">
            <I18NField Widget={Empty} label="">
              {(lang) => (
                <RichTextEditor
                  key={lang}
                  id={lang}
                  value={(zona.comentario || {})[lang] || ''}
                  onChange={this.handleEditorChange(lang)}
                  height="200px"
                />
              )}
            </I18NField>
          </BaseField>

          <hr />

          <h2 className="title is-size-5">Consejo regulador:</h2>
          {CONSEJO_REGULADOR.map(([name, field]) => (
            <Field
              label={name}
              value={(zona.consejo_regulador || {})[field] || ''}
              onChange={this.handleChange(`consejo_regulador.${field}`)}
            />
          ))}

          <hr />

          <h2 className="title is-size-5">Bodegas emblematicas</h2>
          <Suggester
            label="Añadir bodega"
            fetch={async (text, update) => {
              update(await this.suggestBodega(text))
            }}
            render={(item, currentValue) => item.nombre}
            onSelect={(item) => {
              if (zona.bodegas_emblematicas.indexOf(item.id) > -1) {
                alert('La bodega ya existe')
                return
              }
              this.setState({
                zona: {
                  ...zona,
                  bodegas_emblematicas: [item.id, ...zona.bodegas_emblematicas],
                },
              })
            }}
          />
          <DnD
            list={zona.bodegas_emblematicas}
            onChange={(l) => {
              this.setState({
                zona: {
                  ...zona,
                  bodegas_emblematicas: l,
                },
              })
            }}
            getChild={(el, i) => (
              <div
                style={{
                  padding: '8px',
                  cursor: 'pointer',
                  borderBottom: '1px solid #EEE',
                }}
              >
                <div
                  style={{
                    width: '20px',
                    display: 'inline-block',
                    textAlign: 'right',
                    marginRight: '10px',
                  }}
                >
                  {i + 1}
                </div>
                {(this.state.cachedBodegas[el] || {}).nombre || el}
                <button
                  className="button is-danger is-outlined is-small"
                  onClick={() => {
                    this.setState({
                      zona: {
                        ...zona,
                        bodegas_emblematicas: zona.bodegas_emblematicas.filter(
                          (_, index) => index !== i
                        ),
                      },
                    })
                  }}
                  style={{ float: 'right' }}
                >
                  <span className="icon is-small">
                    <i className="fas fa-times"></i>
                  </span>
                </button>
              </div>
            )}
          />

          <hr />

          <h2 className="title is-size-5">Calificaciones añada:</h2>

          <input
            className="input"
            type="number"
            placeholder="Añada"
            style={{ width: '100px' }}
            ref={(ref) => (this.newClasificacionAnyada = ref)}
          />
          <Select
            onChange={(e) => {
              this.setState({ newClasificacionAnyadaPunt: e.target.value })
            }}
            value={this.state.newClasificacionAnyadaPunt}
            options={Object.keys(CALIFICACIONES)
              .sort()
              .map((id) => ({ value: id, text: CALIFICACIONES[id] }))}
            style={{ marginLeft: '5px' }}
          />
          <button
            className="button is-primary is-outlined"
            onClick={() => {
              let anyo = this.newClasificacionAnyada.value
              let punt = this.state.newClasificacionAnyadaPunt
              if (anyo < 1000 || anyo > 3000) {
                alert('Anyada tiene que ser un valor >1000 i <3000')
                return
              }
              this.setState({
                zona: {
                  ...zona,
                  clasificaciones_anyada: {
                    ...zona.clasificaciones_anyada,
                    [anyo]: punt,
                  },
                },
                newClasificacionAnyadaPunt: null,
              })
              this.newClasificacionAnyada.value = ''
            }}
            style={{ marginLeft: '5px' }}
          >
            <span className="icon is-small">
              <i className="fas fa-plus"></i>
            </span>
          </button>

          <table>
            {Object.keys(zona.clasificaciones_anyada).length > 0 ? (
              Object.keys(zona.clasificaciones_anyada)
                .sort()
                .map((k) => (
                  <tr>
                    <td style={{ width: '50px' }}>{k}</td>
                    <td style={{ width: '120px' }}>
                      {CALIFICACIONES[zona.clasificaciones_anyada[k]]}
                    </td>
                    <td>
                      <button
                        className="button is-danger is-outlined is-small"
                        onClick={() => {
                          const calificiones = {
                            ...zona.clasificaciones_anyada,
                          }
                          delete calificiones[k]
                          this.setState({
                            zona: {
                              ...zona,
                              clasificaciones_anyada: calificiones,
                            },
                          })
                        }}
                      >
                        <span className="icon is-small">
                          <i className="fas fa-times"></i>
                        </span>
                      </button>
                    </td>
                  </tr>
                ))
            ) : (
              <tr>
                <em>(No hay ninguna calificación)</em>
              </tr>
            )}
          </table>

          <hr />

          <button
            className="button is-primary"
            disabled={!canModifyContent}
            onClick={async () => {
              let res = await this.save()
              res.ok
                ? this.context.flash('Guardado satisfactoriamente', 'success')
                : this.context.flash(res.err, 'danger')
            }}
          >
            Guardar
          </button>
        </div>
        <div className="column">
          {IMAGES_KEYS.map(([name, field, maxWidth]) => (
            <BaseField label={name}>
              <ImageEditor
                Ctx={this.context}
                style={{ width: '100%', maxWidth }}
                canModifyContent={canModifyContent}
                uploadFieldName={field}
                field={zona[field]}
                folder={'regiones/'}
              />
            </BaseField>
          ))}
        </div>
      </div>
    )
  }

  async save() {
    const ignoreKeys = (data) =>
      Object.keys(data).reduce(
        (acc, k) =>
          GUILLOTINA_KEYS.indexOf(k) >= 0 || k.startsWith('img_')
            ? acc
            : { ...acc, [k]: data[k] },
        {}
      )

    const zona = this.state.zona
    const r = await this.context.client.upsert(this.context.path, {
      id: zona['@name'],
      ...ignoreKeys(zona),
    })
    if (r.status !== 204)
      return {
        ok: false,
        err: 'Error al guardar:\n' + JSON.stringify(await r.json()),
      }
    return { ok: true }
  }

  handleChange(field) {
    return (text) => {
      const zona = { ...this.state.zona }

      const field_list = field.split('.')
      const obj = field_list
        .slice(0, -1)
        .reduce((o, i) => getOrSet(o, i, {}), zona)
      const [key] = field_list.slice(-1)
      obj[key] = text
      this.setState({ zona })
    }
  }

  handleEditorChange(lang) {
    return (text) => {
      let z = this.state.zona
      if (z.comentario === null || z.comentario[lang] !== text) {
        this.setState({
          zona: {
            ...z,
            comentario: {
              ...z.comentario,
              [lang]: text,
            },
          },
        })
      }
    }
  }

  async getBodegas(ids) {
    let bodegas = {}
    let from = 0
    let page = 25
    let moreResults = true

    while (moreResults) {
      let query = {
        size: page,
        from: from,
        query: {
          bool: {
            should: ids.map((id) => ({ match: { id: id } })),
            must: [{ match: { type_name: 'Bodega' } }],
            minimum_should_match: 1,
          },
        },
      }

      const r = await this.context.client.esQuery(query)
      const body = await r.json()
      for (let b of body.member)
        bodegas[b.id] = {
          id: b.id,
          nombre: b.nombre,
        }

      moreResults = Object.keys(bodegas).length < body.items_count || false
      if (moreResults) from += page
    }

    return bodegas
  }

  async suggestBodega(name) {
    let query = {
      query: {
        bool: {
          must: [
            { match_phrase_prefix: { nombre: name } },
            { match: { type_name: 'Bodega' } },
          ],
        },
      },
    }

    let r = await this.context.client.esQuery(query)
    let body = await r.json()

    // Add suggestion results to the cache
    let cachedBodegas = this.state.cachedBodegas
    for (let b of body.member)
      cachedBodegas[b.id] = {
        id: b.id,
        nombre: b.nombre,
      }
    this.setState({ cachedBodegas })

    return body.member
  }

  async componentDidMount() {
    const r = await this.context.client.rest.get(this.context.path)
    let body = await r.json()
    let status = r.status
    if (status === 200) this.setState({ zona: body })
    else this.context.flash(body)

    if (body.bodegas_emblematicas.length === 0) return

    let bodegas = await this.getBodegas(body.bodegas_emblematicas)
    this.setState({
      cachedBodegas: bodegas,
    })
  }
}

ZonaEditor.contextType = TraversalContext

const tabs = {
  Items: PanelItems,
  Edit: ZonaEditor,
  Permissions: PanelPermissions,
  AuditLog: AuditLogTab,
  SEO: SEOTab,
  Submenu: SubmenuTab,
}

const tabsPermissions = {
  Edit: 'guillotina.ViewContent',
  Items: 'guillotina.ViewContent',
  Permissions: 'guillotina.SeePermissions',
  SEO: 'guillotina.ModifyContent',
  Submenu: 'guillotina.ModifyContent',
}

export function ZonaGeoView(props) {
  const ctx = useTraversal()
  const calculated = ctx.filterTabs(tabs, tabsPermissions)
  return (
    <TabsPanelWithLock
      tabs={calculated}
      currentTab="Items"
      editableTabs={['Edit']}
      rightToolbar={<ContextToolbar {...props} />}
      {...props}
    />
  )
}
